import React, { useState, useEffect, useContext, useRef } from "react";
import "./Sale_product.css";
import { Col, Container, Row } from "react-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Product_Card from "../../Common-Component/Product_Card/Product_Card";
import { Context } from "../../../utils/context";
import { ProductsSale } from "../../../utils/apis/Product/Product";
import DoubleHeading from "../../Common-Component/DoubleHeading/DoubleHeading";

library.add(fas);

const Sale_product = () => {
  const { IMG_URL, setShimmerLoader } = useContext(Context);

  const [products, setProducts] = useState([]);
  const [showAll, setShowAll] = useState(false);
  // const [numToShow, setNumToShow] = useState(window.innerWidth < 575 ? 2 : 5);
    const [numToShow, setNumToShow] = useState(20); // Number of products to show initially
const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const sectionRef = useRef(null); // Ref for scroll-to-top

  const getProduct = async () => {
    setShimmerLoader(true);
    const res = await ProductsSale();
    if (res?.success) {
      setProducts(res?.data?.data);
      // set default based on screen size
      // setNumToShow(window.innerWidth < 575 ? 2 : 5);
      // setShowAll(false);
      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getProduct();

    // const handleResize = () => {
    //   const mobile = window.innerWidth < 575;
    //   setIsMobile(mobile);
    //   // setNumToShow(mobile ? 10 : 5); // keep consistent
    //   setShowAll(false);
    // };

    // window.addEventListener("resize", handleResize);
    // return () => window.removeEventListener("resize", handleResize);
  }, []);

 const toggleShowAll = () => {
    if (isMobile) {
      if (numToShow >= products.length) {
        setNumToShow(2);
        // Scroll to the top of the products section
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        setNumToShow((prev) => Math.min(prev + 10, products.length));
      }
    } else {
      if (showAll) {
        setNumToShow(5);
        setShowAll(false);
        // Scroll to the top of the products section
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        setNumToShow(products.length);
        setShowAll(true);
      }
    }
  };

     useEffect(() => {
      window.scrollTo(0, 0);
    }, []);


  return (
    <section className="our-product" ref={sectionRef} id="sale-product">
      <Container fluid>
        {products?.length > 0 && (
          <div className="mb-3 mt-3">
            <DoubleHeading heading={"Sale"} />
          </div>
        )}

        {/* Product Grid (Single Version for both mobile & desktop) */}
        <Row>
          {products.slice(0, numToShow).map((product, index) => {
            const price =
              product?.product_multiple_mains?.[0]?.product_multiple_variants?.[0]?.mrp ||
              product?.product_variants?.[0]?.mrp;

            const cutprice =
              product?.product_multiple_mains?.[0]?.product_multiple_variants?.[0]?.cutting_price ||
              product?.product_variants?.[0]?.cutting_price;

            return (
              <Col
                key={index}
                xxl={3}
                xl={3}
                lg={3}
                md={4}
                sm={4}
                xs={6}
                className="custom_class_product"
              >
                <Product_Card
                  image={IMG_URL + product?.image1}
                  text={product?.name}
                  product_id={product?.id}
                  subText={product?.short_description}
                  price={price}
                  cutprice={cutprice}
                  newest={product?.newest}
                  variant_id={product?.product_variants?.[0]?.id}
                  m_variant_id={
                    product?.product_multiple_mains?.[0]?.product_multiple_variants?.[0]?.id
                  }
                />
              </Col>
            );
          })}
        </Row>

       {/* View All/ View Less Button */}
              {products.length > 0 && (
                <div className="view-all mb-5" onClick={toggleShowAll}>
                  <p>
                    {isMobile
                      ? numToShow >= products.length
                        ? "View Less"
                        : "View More"
                      : showAll
                      ? "View Less"
                      : "View All"}
                  </p>
                </div>
              )}
      </Container>
    </section>
  );
};

export default Sale_product;
